<template>
    <div>
        <JsonLd :json="jsonld" />
        <main id="special210707">
            <!-- 特集Specialコンテンツここから-->
            <!-- KV Section ここから -->
            <section id="kv" class="kv">
                <video playsinline autoplay muted loop>
                    <source src="../../../assets/luxury_travel/luxury_travel01/video/bg_main.mp4" type="video/mp4">
                </video>
                <div id="kv__black"></div><!-- kv__black -->
            </section><!-- kv -->

            <div class="kv__titleArea">
                <p class="kv__title--sub fadeIn">Luxury Travel</p>
                <h2 class="kv__title fadeIn" id="kv__title">Explore the<br>Spiritual<br>Mountains<br>of Muro</h2>
                <p class="playVideo fadeIn" @click="openStreaksPlayer('1d26d23453794718a4a8a4b4f6ad6caf')"><img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel01/svg/play_icon.svg" alt="">Play video</p>
            </div><!-- kv__titleArea -->

            <!-- Lead Section ここから -->
            <section id="lead" class="lead">
                <div class="lead__largeImage">
                    <img src="../../../assets/luxury_travel/luxury_travel01/large_dammy.png" alt="">
                </div><!-- lead__largeImage -->
                <div class="lead__title_wrapper">
                    <h2 class="lead__title fadeIn">Discover Yourself<br>amidst the<br>Tranquility of<br>a Mountain Village</h2>
                </div><!-- lead__title_wrapper -->

                <div class="leadPhotosArea1">
                    <img class="lead__photos01 fadeIn" src="../../../assets/luxury_travel/luxury_travel01/photos01.jpg" alt="">
                    <img class="lead__photos02 fadeIn" src="../../../assets/luxury_travel/luxury_travel01/photos02.jpg" alt="">
                </div><!-- leadPhotosArea1 -->

                <div class="lead__des_wrapper">
                    <p class="lead__des fadeIn">Deep in rural Nara prefecture, among the valleys and peaks of the Muro mountains, lie hidden temples, shrines, and sacred sites with histories stretching back into Japan’s distant past.  </p>
                </div><!-- lead__des_wrapper -->

                <div class="lead__des_wrapper2">
                    <p class="lead__des2 fadeIn">Far from the big cities of Tokyo and Osaka, this region’s villages offer you a glimpse into the spiritual underpinnings of Japan’s unique religious culture. The area’s seclusion and history of ascetic religious training doesn’t mean you’ll be discomfited during your stay, though; luxurious traditional-style wooden buildings give you a chance to sample rural life with modern comforts. </p>
                </div><!-- lead__des_wrapper2 -->

            </section><!-- lead -->



            <!-- Heritage Section ここから -->
            <section class="heritage" id="heritage">
                <img class="heritage_largeImage" src="../../../assets/luxury_travel/luxury_travel01/large_dammy.png" alt="">
                <div class="heritage_titleArea">
                    <h1 class="heritage_title fadeIn" id="heritage_title">From Ancient Times,<br>a Temple<br>that Has Welcomed<br>Female Pilgrims</h1>
                    <p class="playVideo fadeIn" @click="openStreaksPlayer('6f03f5cfbc9f4c95953dcb9293c8e9d5')"><img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel01/svg/play_icon.svg" alt="">Play video</p>
                </div><!-- heritage_titleArea -->
            </section><!-- heritage -->


            <section class="heritage_horizon">
                <div class="heritage_horizon_inner">
                    <div class="japanHeritageWrapper">
                        <img src="../../../assets/luxury_travel/luxury_travel01/svg/japan_heritage.svg" class="japanHeritage">
                    </div><!-- japanHeritageWrapper -->

                    <div class="photo_wrapper heritage__photos01">
                        <img src="../../../assets/luxury_travel/luxury_travel01/photos_tate01.jpg" alt="" class="heritage__photos01_inner">
                    </div><!-- heritage__photos01 -->

                    <p class="heritage__des">Muroji Temple, belonging to the Shingon school of Esoteric Buddhism, is tucked away up a long, winding valley, hidden away from the average traveller. Female pilgrims, traditionally not allowed to visit the popular temples of Koyasan, flocked to Muroji instead, earning the temple the moniker “the women’s Koya.” Restrictions on female visitors to Koyasan were lifted in the early 20th century, but Muroji retains its inviting charm. </p>

                    <div class="photo_wrapper heritage__photos02">
                        <img src="../../../assets/luxury_travel/luxury_travel01/photos03.jpg" alt="" class="heritage__photos02_inner">
                    </div><!-- heritage__photos02 -->

                    <p class="heritage__des2">After stepping through the red-lacquered wood of the Niomon gate, you’re greeted by flights of stone steps leading upwards, past ancient cedars and centuries-old halls. If you’re intrepid enough to climb all the way to the top, you’re rewarded with a view of Muroji’s five-storey pagoda, an exquisite piece of architecture dating back to the late 8th century and a designated National Treasure. The temple also houses several other National Treasures, including a statue of Eleven-faced Kannon, the Buddhist deity of mercy, in the Treasure Hall. </p>

                    <div class="photo_wrapper heritage__photos03">
                        <img class="heritage__photos03_inner" src="../../../assets/luxury_travel/luxury_travel01/photos_tate02.jpg" alt="">
                    </div><!-- heritage__photos03 -->

                    <div class="photo_wrapper heritage__photos04">
                        <img class="heritage__photos04_inner" src="../../../assets/luxury_travel/luxury_travel01/photos04.jpg" alt="">
                    </div><!-- heritage__photos04 -->

                    <div class="heritage__photos05">
                        <img class="heritage__photos05_inner" src="../../../assets/luxury_travel/luxury_travel01/photos_tate03.jpg" alt="">
                    </div><!-- heritage__photos05 -->

                    <div class="heritage__photos06">
                        <img class="heritage__photos06_inner" src="../../../assets/luxury_travel/luxury_travel01/photos05.jpg" alt="">
                    </div><!-- heritage__photos06 -->

                    <p class="heritage__des3">The temple grounds reflect the passing seasons with gorgeous red foliage in autumn or colourful rhododendrons in spring. In the hills behind the temple is Kisho Ryuketsu cave, said to be the sacred home of the rain dragon.</p>

                </div><!-- heritage_horizon_inner -->
            </section><!-- heritage_horizon -->


            <!-- Accommodation Section ここから -->
            <section class="accommodation" id="accommodation">

                <div class="accommodation__largeImage">
                    <video playsinline autoplay muted loop>
                        <source src="../../../assets/luxury_travel/luxury_travel01/video/bg_accommodation.mp4" type="video/mp4">
                    </video>
                    <div id="accommodation__largeImage__black"></div><!-- accommodation__largeImage__black -->
                </div><!-- accommodation__largeImage -->



                <div class="accommodation__title_wrapper">
                    <h2 class="accommodation__title fadeIn">A Hidden Retreat,<br>Looking out over a<br>Sea of Clouds</h2>
                    <p class="playVideo fadeIn" @click="openStreaksPlayer('4e26d195abcb4017bc7329a88b9b2602')"><img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel01/svg/play_icon.svg" alt="">Play video</p>
                </div><!-- accommodation__title_wrapper -->


                <img class="accommodation_tag fadeIn" src="../../../assets/luxury_travel/luxury_travel01/svg/accommodation.svg" alt="Accommodation">

                <div class="accommodation_photo01 fadeIn">
                    <img src="../../../assets/luxury_travel/luxury_travel01/photos06.jpg" alt="">
                    <img src="../../../assets/luxury_travel/luxury_travel01/photos07.jpg" alt="">
                </div><!-- accommodation_photo01 -->

                <div class="accommodation__des_wrapper">
                    <p class="accommodation__des fadeIn">Perched on a hillside and giving you spectacular views southwards to the Muro mountains, Sasayuri-ann is a private luxury accommodation comprised of a pair of traditional-style houses. </p>
                </div><!-- accommodation__des_wrapper -->


                <!-- <div class="accommodation_photo02 fadeIn">
                  <img src="../../assets/luxury_travel/photos02.jpg" alt="">
                </div> --><!-- accommodation_photo02 -->

                <div class="accommodation_des02_wrapper">
                    <p class="accommodation_des02 fadeIn"><i>Zao</i> is an old <i>kominka</i> farmhouse; its blackened wood beams and thatched straw roof evoke the house’s two-hundred-year history. <i>Ozunu</i> is a more modern building nearby, made of natural wood which gives it a clean, fresh air. A highlight of <i>Ozunu</i> is the <i>engawa</i> porch running along the front of the building, perfect for sitting and taking in the sight of the mountain peaks floating on a sea of clouds. </p>
                </div><!-- accommodation__des02_wrapper -->

                <div class="accommodation_photo03 fadeIn">
                    <img src="../../../assets/luxury_travel/luxury_travel01/photos08.jpg" alt="">
                    <img src="../../../assets/luxury_travel/luxury_travel01/photos09.jpg" alt="">
                </div><!-- accommodation_photo03 -->

                <!-- <div class="accommodation_photo04 fadeIn">
                  <img src="../../assets/luxury_travel/photos01.jpg" alt="">
                </div> --><!-- accommodation_photo04 -->

                <div class="accommodation_des03_wrapper">
                    <p class="accommodation_des03 fadeIn">The adjacent garden and its <i>koi</i> carp pond add to the tranquil atmosphere. Don’t be fooled by the traditional architectural style and decorations, though - you’ll also be able to make use of modern conveniences such as wi-fi and air conditioning. The large communal spaces are perfect for relaxing around the <i>irori</i> hearth in a time-honored atmosphere rife with tradition.</p>
                </div><!-- accommodation_des03_wrapper -->

            </section><!-- accommodation -->


            <!-- Cuisine Section  ここから -->
            <section id="cuisine" class="cuisine">

                <div class="cuisine__largeImage">
                    <video playsinline autoplay muted loop>
                        <source src="../../../assets/luxury_travel/luxury_travel01/video/bg_cuisine.mp4" type="video/mp4">
                    </video>
                    <div id="cuisine__largeImage__black"></div><!-- cuisine__largeImage__black -->
                </div><!-- cuisine__largeImage -->

                <img class="cuisine_tag fadeIn" src="../../../assets/luxury_travel/luxury_travel01/svg/cuisine.svg" alt="Cuisine">

                <div class="cuisine__title_wrapper">
                    <h2 class="cuisine__title fadeIn">Exceptional Iga Beef,<br>Traditionally<br>Cooked</h2>
                    <p class="playVideo fadeIn" @click="openStreaksPlayer('7371e693668e4afa910af43e82a5af04')"><img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel01/svg/play_icon.svg" alt="">Play video</p>
                </div><!-- cuisine__title_wrapper -->

                <div class="cuisine_photo01 fadeIn">
                    <img src="../../../assets/luxury_travel/luxury_travel01/photos10.jpg" alt="">
                </div><!-- cuisine_photo01 -->

                <div class="cuisine__des_wrapper">
                    <p class="cuisine__des fadeIn">Japanese beef is among the most highly regarded in the world, with brands such as Kobe or Matsusaka famed among gourmands. Lesser-known areas such as Iga also produce some very high-quality beef, though, easily on par with the big names. At Sasayuri-ann, Iga beef is served in a variety of ways, such as <i>shabu-shabu</i> hot pot style in the farmhouse’s <i>irori</i> hearth; in this method, charcoal is laid on a bed of sand and thin cuts of marbled beef are lowered into the steaming pot of boiling water.  </p>
                </div><!-- cuisine__des_wrapper -->

                <div class="cuisine_photo02 fadeIn">
                    <img src="../../../assets/luxury_travel/luxury_travel01/photos_tate04.jpg" alt="">
                </div><!-- cuisine_photo02 -->

                <div class="cuisine__des02_wrapper">
                    <p class="cuisine__des02 fadeIn">The beef’s colour changes from a rich red through salmon-pink to a tender light grey almost instantaneously, and the meat is ready to melt in your mouth. Combined with the local brand of sake, it’s an unforgettable meal.</p>
                </div><!-- cuisine__des02_wrapper -->


                <div class="cuisine_photo03 fadeIn">
                    <img src="../../../assets/luxury_travel/luxury_travel01/photos11.jpg" alt="">
                </div><!-- cuisine_photo03 -->


                <div class="cuisine__des03_wrapper">
                    <p class="cuisine__des03 fadeIn">If you’re looking for some more local fare, the region has other delicacies for you to try, as well. Yomogiiri Kaitenyaki are a popular snack for visitors to Muroji Temple, a combination of wild aromatic plants and sweet red bean paste nestled in dough and heated to make a piping hot treat.</p>
                </div><!-- cuisine__des03_wrapper -->

            </section><!-- cuisine -->


            <!-- Experience Section ここから -->
            <section id="experience" class="experience">

                <div class="experience__largeImage">
                    <video playsinline autoplay muted loop>
                        <source src="../../../assets/luxury_travel/luxury_travel01/video/bg_experience.mp4" type="video/mp4">
                    </video>
                    <div id="experience__largeImage__black"></div><!-- experience__largeImage__black -->
                </div><!-- experience__largeImage -->

                <div class="experience__title_wrapper">
                    <h2 class="experience__title fadeIn">A Secluded Gorge<br>Used for<br>Spiritual Training<br>for Centuries</h2>
                    <p class="playVideo fadeIn" @click="openStreaksPlayer('b8e3eae3e0a24be2b8717a5677ed0635')"><img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel01/svg/play_icon.svg" alt="">Play video</p>
                </div><!-- experience__title_wrapper -->

                <div class="experience__des_wrapper">
                    <p class="experience__des fadeIn">The Akame 48 Waterfalls are a series of falls that have been used as a spiritual training area for centuries. The noise of the water assisted mountain ascetics in their meditations, helping to clear the mind and reminding them of their closeness to nature. </p>
                </div><!-- experience__des_wrapper -->

                <div class="experience__largeImage2">
                    <img src="../../../assets/luxury_travel/luxury_travel01/large_dammy.png" alt="">
                </div><!-- experience__largeImage2 -->


                <!-- Experience Horizon ここから -->
                <section class="experience_horizon">
                    <div class="experience_horizon_inner">

                        <div class="experienceTagWrapper">
                            <img src="../../../assets/luxury_travel/luxury_travel01/svg/experience.svg" class="experience_tag">
                        </div><!-- experienceTagWrapper -->

                        <div class="photo_wrapper experience__photos01">
                            <img src="../../../assets/luxury_travel/luxury_travel01/photos12.jpg" alt="" class="experience__photos01_inner">
                        </div><!-- experience__photos01 -->

                        <p class="experience__des2">The variety of the waterfalls adds to the area’s beauty; some ripple gently over shallow stones, while others dramatically plunge between rocky outcrops, thrashing the pools below into white foam. </p>

                        <div class="photo_wrapper experience__photos02">
                            <img src="../../../assets/luxury_travel/luxury_travel01/photos13.jpg" alt="" class="experience__photos02_inner">
                        </div><!-- experience__photos02 -->

                        <p class="experience__des3">Sitting on a stone slab by the pure waters of the river, the roar of the falls in your ears, it’s easy to feel the essence of the monks’ meditation rituals. Going deeper into the valley increases your feeling of travelling back into Japan’s past – it’s said that besides mountain ascetics, ninja practitioners would also use this remote area to hone their secretive skills. </p>

                        <div class="photo_wrapper experience__photos03">
                            <img class="experience__photos03_inner" src="../../../assets/luxury_travel/luxury_travel01/photos_tate05.jpg" alt="">
                        </div><!-- experience__photos03 -->

                        <p class="experience__des4">Back at Sasayuri-ann, you can also try your hand at ikebana flower-arranging with a private instructor, or relax and listen to live, exclusive performances of traditional shakuhachi and koto music.</p>


                    </div><!-- experience_horizon_inner -->
                </section><!-- experience_horizon -->

            </section><!-- experience -->


            <div class="maplinkArea">
                <a class="maplink" href="https://www.google.com/maps/d/edit?mid=1GFEI16rlJDLkxKRQfe1WOvKLMIWF8mL6&usp=sharing" target="_blank">See on map <img src="../../../assets/luxury_travel/luxury_travel01/svg/outerlink.svg"></a>
            </div><!-- maplinkArea -->

            <Questionnaire :page-id="pageId" />
            <SeeOtherLuxury />

            <!-- 特集Specialコンテンツここまで-->
            <streaks-player ref="streaks"></streaks-player>
        </main>
    </div>
</template>

<script>
import StreaksPlayer from "@/components/StreaksPlayer/StreaksPlayer";
import ApiRouter from "@/components/Systems/ApiRouter";
import SeeOtherLuxury from '../SeeOtherLuxury';
import Questionnaire from "../Questionnaire.vue";
import JsonLd from "@/components/JsonLd/JsonLd.vue";
export default {
    name: "LuxuryTravel01",
    components: {JsonLd, Questionnaire, StreaksPlayer, SeeOtherLuxury},
    mixins: [ApiRouter],
    data: function () {
        return {
            publicPath: `${process.env.VUE_APP_PUBLIC_PATH}`,
            categoryId: '09788e7d-5beb-4d3b-b644-32d3a36f4755',
            keywords: ['temple&shrine', 'historic building', 'Buddha statue', 'food culture', 'religion', 'mountain'],
            pageId: '1',
            jsonld: {
                "@context": "https://schema.org",
                "@type": "Article",
                "mainEntityOfPage": window.location.href,
                "headline": "Explore the Spiritual Mountains of Muro",
                "description": "Japan Heritage ties together historical sites, shrines, temples, traditional arts, castles, armor," +
                    "and other cultural assets. Find photos, videos, tourist information, and more.",
                "image": [
                    require('../../../assets/luxury_travel/index/luxury01.jpg')
                ],
                "datePublished": "2021/08/18",
                "dateModified": "2023/12/19",
                "author": [{
                    "@type": "Organization",
                    "name": "Japan National Tourism Organization",
                    "url": "https://www.japan.travel/japan-heritage/"
                }]
            }
        }
    },
    mounted: function () {
        document.title = 'Japan Heritage Official Site | Stories and travel information | JNTO'
        let url = this.publicPath + 'js/luxurytravel.js';
        let recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('src', url);
        document.head.appendChild(recaptchaScript);
    },
    methods: {
        openStreaksPlayer: function (id) {
            this.$refs.streaks.open(id);
        },
        goToStoryPage: function (id) {
            this.$router.push({name: 'Popular', params: {id: id, page: 'about'}});
        },
    }
}
</script>

<style src="./LuxuryTravel01.scss" lang="scss" scoped/>
